import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTable } from "primeng/primeng";
import { ProgramService } from "../program.service";
import { ListProgram, ProgramListViewModel, ProgramFilter, DataTablesQuery } from "@models/common";
import { DataTablePaginator } from "../../common/datatable-paginator/datatable-paginator.component";
import { MessageService } from "primeng/components/common/messageservice";

import { ActNowDictionaryItem } from "@models/common";

declare var Sifter: any;

@Component({
    templateUrl: "./program-list.component.html",
    styleUrls: ["./program-list.component.css"]
})

export class ProgramListComponent implements OnInit {
    nameInput: string;
    addressInput: string;
    agencyInput: string;
    agencyResults: string[];
    agencyList: ActNowDictionaryItem[];
    cityInput: string;
    cityResults: string[];
    cityList: ActNowDictionaryItem[];
    programList: ListProgram[];
    programFilter: ProgramFilter = new ProgramFilter;
    totalCount: number;
    mergeToolModal: boolean = false;
    exportLoading: boolean = false;
    public blockUi = false;
    public spinnerClass = "hideSpinner";

    public rowCount: number = 10;
    public mapRows: number = 10;


    @ViewChild("dl") dl;
    @ViewChild("DT") dt: DataTable;
    @ViewChild("dtp") dtp: DataTablePaginator;
    constructor(private programService: ProgramService, private router: Router, private messageService: MessageService) { }

    ngOnInit(): void {
        this.getSelectLists();
    }

    getSelectLists() {
        this.programService.getSelectLists().subscribe(data => {
            console.log(data);
            this.agencyList = data.agencies;
            this.cityList = data.cities;
        });
    }

    searchAgency(event) {
        this.agencyResults = [];

        let sifter = new Sifter(this.agencyList);

        let result = sifter.search(event.query, {
            fields: ["text"],
            sort: [{ field: "text", direction: "asc" }],
            limit: 100,
        });

        let agencies = result.items.map(x => this.agencyList[x.id].text);

        this.agencyResults = [...agencies];

    }

    searchCity(event) {
        this.cityResults = [];

        let sifter = new Sifter(this.cityList);

        let result = sifter.search(event.query, {
            fields: ["text"],
            sort: [{ field: "text", direction: "asc" }],
            limit: 100,
        });

        let cities = result.items.map(x => this.cityList[x.id].text);

        this.cityResults = [...cities];
    }

    applyFilters() {
        this.programFilter.address = this.addressInput;
        this.programFilter.agency = this.agencyInput;
        this.programFilter.city = this.cityInput;
        this.programFilter.name = this.nameInput;
        this.dt.reset();

    }

    download(url: string, filename: string): void {
        let link = this.dl.nativeElement;
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    export() {
        this.loading();
        this.exportLoading = true;
        let filter = new ProgramFilter();
        filter.address = this.addressInput;
        filter.agency = this.agencyInput;
        filter.city = this.cityInput;
        filter.name = this.nameInput;

        this.programService.exportPrograms(filter).finally(() => this.exportLoading = false).subscribe(
            response => {
                let b64 = "data:application/vnd.ms-excel;base64," + response;
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    let blob = this.convertBase64ToBlob(b64);
                    window.navigator.msSaveOrOpenBlob(blob, "Program_List_Export.xlsx");
                } else {
                    let url = this.convertBase64ToUrl(b64);
                    this.download(url, "Program_List_Export.xlsx");
                }
                this.finshedLoading();
            },
            error => {
                this.finshedLoading();
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "An error occurred while attempting to export the program list, please try again"
                });
            }
        );
    }

    loading(): void {
        this.blockUi = true;
        this.spinnerClass = "showSpinner";
    }

    finshedLoading(): void {
        this.blockUi = false;
        this.spinnerClass = "hideSpinner";
    }

    public convertBase64ToUrl(base64: string): string {
        let byteString = atob(base64.split(",")[1]);

        let mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        let blob = new Blob([ab], { type: mimeString });
        let url = window.URL.createObjectURL(blob);
        return url;
    }

    public convertBase64ToBlob(base64: string): Blob {
        let byteString = atob(base64.split(",")[1]);

        let mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        let blob = new Blob([ab], { type: mimeString });
        return blob;
    }

    clearFiltersResetTable() {
        this.addressInput = undefined;
        this.agencyInput = undefined;
        this.cityInput = undefined;
        this.nameInput = undefined;
        this.programFilter = new ProgramFilter;
        this.dt.reset();
    }

    loadProgramsLazy(event) {
        let request = new DataTablesQuery;
        request.first = event.first;
        request.rows = event.rows;
        request.sortField = event.sortField;
        request.sortOrder = event.sortOrder;
        request.filters = this.programFilter;
        this.programService.programListQuery(request).subscribe(data => {
            this.totalCount = data.totalCount;
            this.programList = data.programList;
        });
    }

    navigateToProgram(event) {
        this.router.navigate(["/program/" + event.data.id + "/contact-info"]);
    }

    updateRowCount(): void {
        this.mapRows = +this.rowCount;
        setTimeout(() => this.dtp.updateRows());
    }

}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/programs/program-list/program-list.component.ts